export const HAS_ACCEPTED_GEOLOCATION_KEY = 'has_accepted_geolocation'
